var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg bg-1"},[_c('NavBar',{attrs:{"title":_vm.$t('title'),"items":_vm.menuItems},on:{"select":function($event){return _vm.menuSelect($event)}}}),_c('PingView',{attrs:{"ping":_vm.game.ping}}),_c('PageTitle',{attrs:{"text":_vm.$t('round') +
      ' ' +
      _vm.game.round.number +
      ' ' +
      _vm.$t('of_rounds') +
      ' ' +
      _vm.game.settings.rounds}}),_c('b-row',[_c('b-col',{staticClass:"main-panel"},[_c('GameInput',{attrs:{"game":_vm.game}})],1),_c('b-col',{staticClass:"side-panel"},[_c('PlayerProgress',{staticClass:"player-progress-panel",attrs:{"game":_vm.game}})],1)],1),_c('Chat',{attrs:{"game":_vm.game}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }